import { CirclePacking } from '../../models/circlePackingModel';

export const findParentNode: (node: CirclePacking, nodeId: string, depth?: number) => any = (node, nodeId, depth = 0) => {
  if (node.children) {
    const matchNode = node.children.find((child) => child.id === nodeId);

    if (matchNode) {
      // if match but the depth is zero we don't return parent
      // because we don't want to return the root node
      return depth ? node : null;
    }

    return node.children.reduce((match: CirclePacking, child) => match || findParentNode(child, nodeId, depth + 1), null);
  }
  return null;
};
